import React, { useState } from 'react';
import { TailSpin } from 'react-loading-icons';

const AppTokenInput = ({ onSubmit, loading, error }) => {
    const [value, setValue] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (value.trim()) onSubmit(value.trim());
    };

    return (
        <div className="mt-5 mb-5">
            <h2>Zugang zur Bewerbung</h2>
            <p>Bitte geben Sie Ihren Zugangscode ein, den Sie per E-Mail erhalten haben.</p>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label className="form-label" htmlFor="token-input">Zugangscode</label>
                    <input
                        id="token-input"
                        type="text"
                        className={`form-control${error ? ' is-invalid' : ''}`}
                        value={value}
                        onChange={e => setValue(e.target.value)}
                        disabled={loading}
                        autoFocus
                    />
                    {error && <div className="invalid-feedback">{error}</div>}
                </div>
                <div className="d-flex justify-content-end mt-5">
                    <button type="submit" className="btn btn-secondary" disabled={loading || !value.trim()}>
                        {loading ? <TailSpin stroke="#fff" height="1em" /> : 'Weiter'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AppTokenInput;